import React, {createRef} from 'react';
import Button from '../Components/Button.jsx';
import InteractiveMessage from './InteractiveMessage.jsx';

/**
 * Class to handle generic function of a component that utilizes a list of buttons.
 */
export default class ButtonListComponent extends InteractiveMessage {
    constructor(props) {
        super(props);

        this.state = {
            userInteracted: false
        }

        this.buttonListRef = createRef();
    }

    /**
     * Determines the type value to use based on a quick reply or button template button.
     * @param {Object} button The button being mapped.
     * @returns
     */
    determineButtonType(button) {
        if (button.content_type) {
            return button.content_type;
        }
        else if (button.type) {
            return button.type;
        }
        else {
            return '';
        }
    }

    /**
     * Maps the button list unless the passthrough is from chat history or if the user has interacted
     * with the buttons and moving the conversation flow forward.
     * @param {Array<Object>} buttons
     * @returns The button list or nothing.
     */
    generateButtonList(buttons) {
        if (this.props.message.isChatHistory || this.state.userInteracted) {
            return <div className='button-list' ref={this.interactionRef}></div>
        }

        return  <ul className='button-list' ref={this.interactionRef}>
                    {buttons.map((button) => {
                        return <Button
                            key={button}
                            title={button.title}
                            url={button.url}
                            value={button.value}
                            payload={button.payload}
                            type={this.determineButtonType(button)}
                            displayAsList />
                    })}
                </ul>
    }
}